// Shared with CountryExchangeTool (components/DemarchesPermis/components) so both type-aheads
// rank results the same way instead of reimplementing accent-insensitive matching twice.
const normalize = (value: string): string => (
  value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
);

const COUNTRY_ALIASES: Record<string, string[]> = {
  'Royaume-Uni': ['uk', 'angleterre', 'grande-bretagne', 'grande bretagne', 'ecosse', 'pays de galles', 'irlande du nord'],
  'États-Unis': ['usa', 'etats unis', 'amerique'],
  'Émirats arabes unis': ['eau', 'dubai'],
  'Pays-Bas': ['hollande'],
};

const matchesAlias = (countryName: string, normalizedQuery: string): boolean => (
  normalizedQuery.length >= 2
  && (COUNTRY_ALIASES[countryName] || []).some((alias) => alias.startsWith(normalizedQuery))
);

const matchCountries = <T extends { name: string }>(query: string, countries: T[]): T[] => {
  const normalizedQuery = normalize(query.trim());
  if (!normalizedQuery) {
    return [];
  }
  const aliased = countries.filter((country) => matchesAlias(country.name, normalizedQuery));
  const rest = countries.filter((country) => !aliased.includes(country));
  const startsWith = rest.filter((country) => normalize(country.name).startsWith(normalizedQuery));
  const contains = rest.filter(
    (country) => !normalize(country.name).startsWith(normalizedQuery)
      && normalize(country.name).includes(normalizedQuery),
  );
  return aliased.concat(startsWith, contains).slice(0, 8);
};

export { normalize, matchCountries };
